import { Paper, PaperBorderType } from '@roc/ui';
import clsx from 'clsx';
import React from 'react';
import { useStatusDashboardStyles } from './statusDashboardStyles';

interface DashboardCardProps {
  title?: string;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export const DashboardCard = ({ title, subtitle, right, className, children }: DashboardCardProps) => {
  const classes = useStatusDashboardStyles();
  return (
    <Paper borderType={PaperBorderType.NO_BORDER} className={clsx(classes.card, className)}>
      {title && (
        <div className={classes.cardHeader}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <h2 className={classes.cardTitle}>{title}</h2>
            {subtitle && <span className={classes.muted}>{subtitle}</span>}
          </div>
          {right && <span className={classes.muted}>{right}</span>}
        </div>
      )}
      {children}
    </Paper>
  );
};
